(function () {
  'use strict';

  var modal = document.getElementById('cart-upsell-modal');
  if (!modal) return;

  var configEl = document.getElementById('cart-upsell-config');
  var productsEl = document.getElementById('cart-upsell-products');
  if (!configEl || !productsEl) return;

  var config, products;
  try {
    config = JSON.parse(configEl.textContent);
    products = JSON.parse(productsEl.textContent);
  } catch (e) {
    console.error('[cart-upsell] Config parse error', e);
    return;
  }

  var moneyFormat = modal.getAttribute('data-money-format') || '{{amount}} kr';

  var headlineEl = modal.querySelector('[data-cart-upsell-headline]');
  var groupsEl = modal.querySelector('[data-cart-upsell-groups]');
  var justAddedEl = modal.querySelector('[data-cart-upsell-just-added]');
  var checkoutBtn = modal.querySelector('[data-cart-upsell-checkout]');

  var MAIN_HANDLE = config.main_product_handle;
  var STRENGTH_OPTION_NAME = 'Variant';

  // ---------- Block dialog.showModal() under ATC ----------
  // Vessel öppnar drawer via dialog.showModal() — vi monkey-patchar HTMLDialogElement
  // så att alla showModal()-anrop ignoreras under ATC-flödet.
  var blockShowModal = false;
  var nativeShowModal = HTMLDialogElement.prototype.showModal;
  var nativeShow = HTMLDialogElement.prototype.show;
  HTMLDialogElement.prototype.showModal = function () {
    if (blockShowModal && !this.closest('#cart-upsell-modal')) {
      return; // svälj anropet
    }
    return nativeShowModal.apply(this, arguments);
  };
  HTMLDialogElement.prototype.show = function () {
    if (blockShowModal && !this.closest('#cart-upsell-modal')) {
      return;
    }
    return nativeShow.apply(this, arguments);
  };

  // ---------- Discount code + cart attribute helpers (definierade tidigt så alla kan använda dem) ----------
  var DISCOUNT_CODE = 'TILLBEHOR20';
  var discountApplyInFlight = false;

  function hasAccessoryInCart(cart) {
    var accessories = config.accessories || [];
    for (var i = 0; i < accessories.length; i++) {
      if (cartHasProductHandle(cart, accessories[i].handle)) return true;
    }
    return false;
  }

  function setCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function (err) {
      console.error('[cart-upsell] setCartAttributes error', err);
    });
  }

  function applyDiscountCode() {
    if (discountApplyInFlight) return;
    discountApplyInFlight = true;
    fetch('/discount/' + DISCOUNT_CODE, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    })
      .catch(function () {})
      .then(function () { discountApplyInFlight = false; });
  }

  function removeDiscountCode() {
    fetch('/discount/clear', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    }).catch(function () {});
  }

  // ---------- Disable Vessel auto-open + watch drawer open ----------
  function disableAutoOpen() {
    document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function (el) {
      el.removeAttribute('auto-open');
    });
  }
  disableAutoOpen();
  setInterval(disableAutoOpen, 500);

  // Flagga som säger om vi förväntar oss att en cart-add-fetch händer
  var atcInProgress = false;

  // Watch för drawer-öppning — om den öppnas medan ATC pågår, stäng den direkt
  var drawerOpenObserver = new MutationObserver(function (mutations) {
    if (!atcInProgress) return;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.attributeName === 'open') {
        var dlg = m.target;
        if (dlg.tagName === 'DIALOG' && dlg.hasAttribute('open') && !dlg.closest('#cart-upsell-modal')) {
          try { if (typeof dlg.close === 'function') dlg.close(); } catch (e) {}
          dlg.removeAttribute('open');
        }
      }
    }
  });
  drawerOpenObserver.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['open']
  });

  // ---------- Cart drawer detection / control (Vessel) ----------
  function isCartDrawerOpen() {
    var dlg = document.querySelector('cart-drawer-component dialog[open]');
    return !!dlg;
  }

  function forceCloseCartDrawer() {
    document.querySelectorAll('cart-drawer-component dialog[open]').forEach(function (dlg) {
      try { if (typeof dlg.close === 'function') dlg.close(); } catch (e) {}
      dlg.removeAttribute('open');
    });
    document.body.classList.remove('cart-drawer-open', 'overflow-hidden', 'no-scroll', 'scroll-lock');
    document.documentElement.classList.remove('scroll-lock');
  }

  function openCartDrawer() {
    var trigger = document.querySelector('cart-drawer-component button[aria-haspopup="dialog"], [data-testid="cart-drawer-trigger"]');
    if (trigger) {
      try { trigger.click(); } catch (e) {}
    }
  }

  // ---------- Money formatting ----------
  function formatMoney(cents) {
    function withDelimiters(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = num.toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return dollars + decPart;
    }
    var value = cents / 100;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDelimiters(value, 2, ',', '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDelimiters(value, 0, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDelimiters(value, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDelimiters(value, 0, '.'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withDelimiters(value, 2, ' ', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, withDelimiters(value, 0, ' '))
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, withDelimiters(value, 2, ' ', '.'));
  }

  // ---------- Cart helpers ----------
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function getMainCartLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === MAIN_HANDLE) return cart.items[i];
    }
    return null;
  }

  function cartHasProductHandle(cart, handle) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === handle) return true;
    }
    return false;
  }

  function getCurrentTier(qty) {
    var sorted = (config.tier_thresholds || []).slice().sort(function (a, b) { return b.qty_min - a.qty_min; });
    for (var i = 0; i < sorted.length; i++) {
      if (qty >= sorted[i].qty_min) return sorted[i];
    }
    return sorted[sorted.length - 1] || { qty_min: 1, discount: 0 };
  }

  // Hämtar valt styrke-värde (t.ex. "Standard" / "Extra stark") från en cart-rad
  function getLineStrength(line) {
    if (line.options_with_values && line.options_with_values.length) {
      for (var i = 0; i < line.options_with_values.length; i++) {
        if (line.options_with_values[i].name === STRENGTH_OPTION_NAME) {
          return line.options_with_values[i].value;
        }
      }
    }
    // Fallback om options_with_values saknas: variant_title kan innehålla flera
    // optionsvärden separerade med " / " (t.ex. "0,5 meter / Extra stark")
    if (line.variant_title) {
      var parts = line.variant_title.split(' / ');
      return parts[parts.length - 1];
    }
    return '';
  }

  // ---------- Render helpers ----------
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(str) { return escapeHtml(str); }

  function renderJustAdded(cart) {
    var mainLine = getMainCartLine(cart);
    if (!mainLine) { justAddedEl.innerHTML = ''; return; }

    var meters = (mainLine.quantity * 0.5).toFixed(1).replace('.', ',');
    var skenaWord = mainLine.quantity === 1 ? 'skena' : 'skenor';
    var strengthText = getLineStrength(mainLine);
    var displayPrice = mainLine.final_line_price || mainLine.line_price || 0;
    var compareAt = mainLine.original_line_price || 0;
    var hasDiscount = compareAt > displayPrice;

    var priceHtml = hasDiscount
      ? '<span style="color:#b91c1c;">' + formatMoney(displayPrice) + '</span> ' +
        '<span style="color:#999;text-decoration:line-through;font-weight:400;font-size:11px;">' + formatMoney(compareAt) + '</span>'
      : formatMoney(displayPrice);

    var variantLineText = (strengthText ? escapeHtml(strengthText) + ' · ' : '') +
      mainLine.quantity + ' ' + skenaWord + ' · ' + meters + ' m';

    justAddedEl.innerHTML =
      '<div class="cart-upsell-modal__added-container">' +
        '<div class="cart-upsell-modal__added-line">' +
          '<div class="cart-upsell-modal__added-check" aria-hidden="true">' +
            '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M3 8.5L6.5 12L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</div>' +
          '<div class="cart-upsell-modal__added-info">' +
            '<div class="cart-upsell-modal__added-title">' + escapeHtml(mainLine.product_title) + '</div>' +
            '<div class="cart-upsell-modal__added-variant">' + variantLineText + '</div>' +
          '</div>' +
          '<div class="cart-upsell-modal__added-price">' + priceHtml + '</div>' +
        '</div>' +
      '</div>';
  }

  function renderUpgradeGroup(cart) {
    var mainLine = getMainCartLine(cart);
    if (!mainLine) return '';

    var currentQty = mainLine.quantity;
    var currentTier = getCurrentTier(currentQty);
    var unitPrice = (mainLine.original_price || mainLine.price);

    var stepsHtml = (config.upgrade_steps || []).map(function (step) {
      var isCurrent = currentQty === step.to_qty;
      var alreadyAt = currentQty >= step.to_qty;

      var pricePerSkena = Math.round(unitPrice * (1 - step.saves_pct / 100));
      var totalAtStep = pricePerSkena * step.to_qty;
      var totalOriginal = unitPrice * step.to_qty;
      var savesAmount = totalOriginal - totalAtStep;

      if (isCurrent) {
        return '' +
          '<div class="cart-upsell-upgrade is-current">' +
            '<div class="cart-upsell-upgrade__info">' +
              '<div class="cart-upsell-upgrade__title">' + escapeHtml(step.label) + '</div>' +
              '<div class="cart-upsell-upgrade__badges">' +
                '<span class="cart-upsell-upgrade__badge">−' + step.saves_pct + '%</span>' +
                (step.free_shipping ? '<span class="cart-upsell-upgrade__badge cart-upsell-upgrade__badge--shipping">Fri frakt</span>' : '') +
              '</div>' +
            '</div>' +
            '<div class="cart-upsell-upgrade__price-row">' +
              '<span class="cart-upsell-upgrade__price">' + formatMoney(totalAtStep) + '</span>' +
            '</div>' +
            '<div class="cart-upsell-upgrade__current-label">✓ Vald</div>' +
          '</div>';
      }
      if (alreadyAt) return '';

      return '' +
        '<div class="cart-upsell-upgrade">' +
          '<div class="cart-upsell-upgrade__info">' +
            '<div class="cart-upsell-upgrade__title">' + escapeHtml(step.label) + '</div>' +
            '<div class="cart-upsell-upgrade__badges">' +
              '<span class="cart-upsell-upgrade__badge">−' + step.saves_pct + '%</span>' +
              (step.free_shipping ? '<span class="cart-upsell-upgrade__badge cart-upsell-upgrade__badge--shipping">Fri frakt</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="cart-upsell-upgrade__price-row">' +
            '<span class="cart-upsell-upgrade__price">' + formatMoney(totalAtStep) + '</span>' +
            '<span class="cart-upsell-upgrade__savings">Spara ' + formatMoney(savesAmount) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-upsell-upgrade__btn" data-upgrade-qty="' + step.to_qty + '" data-line-key="' + escapeAttr(mainLine.key) + '">' +
            'Uppgradera' +
          '</button>' +
        '</div>';
    }).filter(Boolean).join('');

    if (!stepsHtml) return '';

    var subtitleText = currentTier.discount > 0
      ? 'Du sparar redan ' + currentTier.discount + '% — uppgradera för ännu mer rabatt'
      : 'Köp fler meter, spara mer';

    return '' +
      '<div class="cart-upsell-group">' +
        '<div class="cart-upsell-group__header">' +
          '<div class="cart-upsell-group__title">Uppgradera din beställning</div>' +
          '<div class="cart-upsell-group__subtitle">' + subtitleText + '</div>' +
        '</div>' +
        '<div class="cart-upsell-group__products">' + stepsHtml + '</div>' +
      '</div>';
  }

  function renderAccessoriesGroup(cart) {
    var visibleAccessories = (config.accessories || []).filter(function (a) {
      return !!products[a.handle];
    });
    if (visibleAccessories.length === 0) return '';

    // Bygg en lookup av cart lines per handle (så vi kan visa qty + line_key)
    var cartLinesByHandle = {};
    for (var i = 0; i < cart.items.length; i++) {
      cartLinesByHandle[cart.items[i].handle] = cart.items[i];
    }

    var productsHtml = visibleAccessories.map(function (a) {
      return renderAddon(a, cartHasProductHandle(cart, a.handle), cartLinesByHandle);
    }).join('');

    return '' +
      '<div class="cart-upsell-group">' +
        '<div class="cart-upsell-group__header">' +
          '<div class="cart-upsell-group__title">Tillbehör</div>' +
          '<div class="cart-upsell-group__subtitle">20% rabatt när du köper med gardinskenan</div>' +
        '</div>' +
        '<div class="cart-upsell-group__products">' + productsHtml + '</div>' +
      '</div>';
  }

  function renderAddon(a, isAdded, cartLinesByHandle) {
    var data = products[a.handle];
    var firstVariant = (data.variants || [])[0];
    if (!firstVariant) return '';

    var price = firstVariant.price;
    var compareAt = firstVariant.compare_at_price;
    var discount = a.expected_discount || 0;
    var discountedPrice = discount > 0 ? Math.round(price * (1 - discount / 100)) : price;

    var rightSide;
    if (isAdded) {
      // Hitta nuvarande qty på line item som matchar denna handle
      var currentQty = 1;
      var currentLineKey = '';
      if (cartLinesByHandle && cartLinesByHandle[a.handle]) {
        currentQty = cartLinesByHandle[a.handle].quantity;
        currentLineKey = cartLinesByHandle[a.handle].key;
      }

      rightSide =
        '<div class="cart-upsell-addon__qs" data-line-key="' + escapeAttr(currentLineKey) + '">' +
          '<button type="button" class="cart-upsell-addon__qs-btn" data-qs-decrease aria-label="Minska antal">−</button>' +
          '<span class="cart-upsell-addon__qs-value" data-qs-value>' + currentQty + '</span>' +
          '<button type="button" class="cart-upsell-addon__qs-btn" data-qs-increase aria-label="Öka antal">+</button>' +
        '</div>';
    } else {
      rightSide =
        '<button type="button" class="cart-upsell-addon__btn" data-add-variant="' + firstVariant.id + '">' +
          'Lägg till' +
        '</button>';
    }

    var addedClass = isAdded ? ' is-added' : '';

    var priceHtml = discount > 0
      ? '<span class="cart-upsell-addon__price-sale">' + formatMoney(discountedPrice) + '</span>' +
        '<span class="cart-upsell-addon__price-compare">' + formatMoney(price) + '</span>'
      : (compareAt && compareAt > price
          ? '<span class="cart-upsell-addon__price-sale">' + formatMoney(price) + '</span>' +
            '<span class="cart-upsell-addon__price-compare">' + formatMoney(compareAt) + '</span>'
          : '<span>' + formatMoney(price) + '</span>'
        );

    var badgeHtml = discount > 0
      ? '<span class="cart-upsell-addon__badge">−' + discount + '%</span>'
      : '';

    return '' +
      '<div class="cart-upsell-addon' + addedClass + '" data-handle="' + escapeAttr(a.handle) + '">' +
        '<div class="cart-upsell-addon__image-wrap">' +
          '<img src="' + escapeAttr(data.image) + '" alt="' + escapeAttr(data.title) + '" loading="lazy" />' +
        '</div>' +
        '<div class="cart-upsell-addon__info">' +
          '<div class="cart-upsell-addon__title">' + escapeHtml(data.title) + '</div>' +
          (badgeHtml ? '<div class="cart-upsell-addon__badges">' + badgeHtml + '</div>' : '') +
          '<div class="cart-upsell-addon__price">' + priceHtml + '</div>' +
        '</div>' +
        rightSide +
      '</div>';
  }

  function renderAll(cart) {
    groupsEl.innerHTML = renderUpgradeGroup(cart) + renderAccessoriesGroup(cart);
  }

  // ---------- Modal show/hide ----------
  var lastFocusedElement = null;

  function showModal(cart) {
    var mainLine = getMainCartLine(cart);
    if (!mainLine) return false;

    // Håll showModal-spärren ON så länge popupen är öppen
    blockShowModal = true;

    setCartAttributes({
      'upsell_popup_shown': 'true',
      'upsell_popup_shown_at': new Date().toISOString()
    });

    forceCloseCartDrawer();
    renderJustAdded(cart);
    renderAll(cart);

    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { modal.classList.add('is-open'); }, 10);
    if (checkoutBtn) checkoutBtn.focus();

    setTimeout(forceCloseCartDrawer, 50);
    setTimeout(forceCloseCartDrawer, 200);
    return true;
  }

  function hideModal(openDrawerAfter) {
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocusedElement && lastFocusedElement.focus) lastFocusedElement.focus();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      // Lyft showModal-spärren — nu kan drawern öppnas igen
      blockShowModal = false;

      if (openDrawerAfter) {
        setTimeout(openCartDrawer, 100);
      }
    }, 200);
  }

  // ---------- Add accessory ----------
  function addAccessoryToCart(variantId, btn) {
    if (!variantId) return Promise.resolve();
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Lägger till...'; }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Cart-Upsell': '1' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { '_source': 'cart-upsell-popup' } }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (added) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        if (btn) {
          btn.disabled = false;
          btn.textContent = '✓ Tillagd';
          btn.classList.add('cart-upsell-addon__btn--added-feedback');
        }

        var addedHandle = (added && added.items && added.items[0] && added.items[0].handle)
          || (added && added.handle)
          || 'unknown';
        setCartAttributes({
          'upsell_added_accessory': addedHandle,
          'upsell_via_popup': 'true'
        });

        return new Promise(function (resolve) { setTimeout(resolve, 400); })
          .then(fetchCart)
          .then(function (cart) {
            if (hasAccessoryInCart(cart)) {
              applyDiscountCode();
            }
            setTimeout(function () {
              if (modal.classList.contains('is-open')) {
                renderAll(cart);
                renderJustAdded(cart);
              }
            }, 1200);
          });
      })
      .catch(function (err) {
        console.error('[cart-upsell] add error', err);
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      });
  }

  // ---------- Upgrade qty ----------
  function upgradeQuantity(lineKey, newQty, btn) {
    if (!lineKey || !newQty) return Promise.resolve();
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Uppdaterar...'; }

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Cart-Upsell': '1' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        if (btn) {
          btn.disabled = false;
          btn.textContent = '✓ Uppgraderat';
          btn.classList.add('cart-upsell-addon__btn--added-feedback');
        }

        var meters = (newQty * 0.5).toFixed(1).replace('.', ',');
        setCartAttributes({
          'upsell_upgraded_to': newQty + '_skenor_' + meters + 'm',
          'upsell_via_popup': 'true'
        });

        setTimeout(function () {
          if (modal.classList.contains('is-open')) {
            renderAll(cart);
            renderJustAdded(cart);
          }
        }, 1200);
      })
      .catch(function (err) {
        console.error('[cart-upsell] upgrade error', err);
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      });
  }

  // ---------- Change accessory qty (via QS i popup) ----------
  function changeAccessoryQty(lineKey, newQty, container) {
    if (!lineKey || newQty < 1) return;

    // Disable QS-knappar tillfälligt
    var qsButtons = container.querySelectorAll('.cart-upsell-addon__qs-btn');
    qsButtons.forEach(function (b) { b.disabled = true; });

    // Optimistic UI: uppdatera värdet direkt
    var qsValueEl = container.querySelector('[data-qs-value]');
    if (qsValueEl) qsValueEl.textContent = newQty;

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Cart-Upsell': '1' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        qsButtons.forEach(function (b) { b.disabled = false; });

        // Re-rendera popupen med ny cart
        setTimeout(function () {
          if (modal.classList.contains('is-open')) {
            renderAll(cart);
            renderJustAdded(cart);
          }
        }, 300);
      })
      .catch(function (err) {
        console.error('[cart-upsell] qs change error', err);
        qsButtons.forEach(function (b) { b.disabled = false; });
      });
  }

  // ---------- Checkout ----------
  function goToCheckout(btn) {
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Går till kassan...';
    }

    fetchCart().then(function (cart) {
      var rootPath = '/';
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        rootPath = window.Shopify.routes.root;
      }

      if (hasAccessoryInCart(cart)) {
        window.location.href = rootPath + 'discount/' + DISCOUNT_CODE + '?redirect=' + encodeURIComponent(rootPath + 'checkout');
      } else {
        window.location.href = rootPath + 'checkout';
      }
    }).catch(function () {
      window.location.href = '/checkout';
    });
  }

  // ---------- Event handlers ----------
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-upsell-close]')) {
      e.preventDefault();
      hideModal(true);
      return;
    }
    if (e.target.closest('[data-cart-upsell-checkout]')) {
      e.preventDefault();
      goToCheckout(e.target.closest('[data-cart-upsell-checkout]'));
      return;
    }
    var addBtn = e.target.closest('[data-add-variant]');
    if (addBtn) {
      e.preventDefault();
      addAccessoryToCart(addBtn.getAttribute('data-add-variant'), addBtn);
      return;
    }
    var upgradeBtn = e.target.closest('[data-upgrade-qty]');
    if (upgradeBtn) {
      e.preventDefault();
      var newQty = parseInt(upgradeBtn.getAttribute('data-upgrade-qty'), 10);
      var lineKey = upgradeBtn.getAttribute('data-line-key');
      upgradeQuantity(lineKey, newQty, upgradeBtn);
      return;
    }

    // QS-knappar på tillbehör
    var qsIncrease = e.target.closest('[data-qs-increase]');
    var qsDecrease = e.target.closest('[data-qs-decrease]');
    if (qsIncrease || qsDecrease) {
      e.preventDefault();
      var qsContainer = (qsIncrease || qsDecrease).closest('.cart-upsell-addon__qs');
      if (!qsContainer) return;
      var qsLineKey = qsContainer.getAttribute('data-line-key');
      var qsValueEl = qsContainer.querySelector('[data-qs-value]');
      var currentQs = parseInt(qsValueEl.textContent, 10) || 1;
      var newQs = qsIncrease ? (currentQs + 1) : Math.max(1, currentQs - 1);
      if (newQs === currentQs) return;
      changeAccessoryQty(qsLineKey, newQs, qsContainer);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) hideModal(true);
  });

  // ---------- ATC interception (fetch monkey-patch) ----------
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isCartMutation = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);

    // Aktivera drawer-spärr ENDAST om:
    //   1. Vår popup redan är öppen (då vill vi inte att drawer öppnas över)
    //   2. Detta är en cart/add (kan vara ATC av huvudprodukten — bestäms efter)
    var popupOpen = modal.classList.contains('is-open');
    var shouldBlockDuringMutation = popupOpen || isCartAdd;

    if (isCartMutation && shouldBlockDuringMutation) {
      blockShowModal = true;
      atcInProgress = true;
      var killInterval = setInterval(forceCloseCartDrawer, 50);
      setTimeout(function () {
        clearInterval(killInterval);
        atcInProgress = false;
        if (!modal.classList.contains('is-open')) {
          blockShowModal = false;
        }
      }, 2000);
    }

    if (!isCartAdd) return originalFetch.apply(this, arguments);

    var fromUpsell = false;
    if (init && init.headers) {
      if (typeof init.headers.get === 'function') {
        fromUpsell = init.headers.get('X-Cart-Upsell') === '1';
      } else {
        fromUpsell = init.headers['X-Cart-Upsell'] === '1';
      }
    }

    var promise = originalFetch.apply(this, arguments);
    if (fromUpsell) return promise;

    // Spärra alla showModal()-anrop på native dialogs (Vessel använder detta för drawer)
    blockShowModal = true;
    atcInProgress = true;
    var drawerKillInterval = setInterval(forceCloseCartDrawer, 50);
    setTimeout(function () {
      clearInterval(drawerKillInterval);
      atcInProgress = false;
      blockShowModal = false;
    }, 2000);

    return promise.then(function (response) {
      var cloned = response.clone();
      cloned.json().then(function (data) {
        var addedHandle = null;
        if (data && data.items && data.items.length) addedHandle = data.items[data.items.length - 1].handle;
        else if (data && data.handle) addedHandle = data.handle;

        if (addedHandle !== MAIN_HANDLE) return;

        setTimeout(function () {
          fetchCart().then(function (cart) {
            forceCloseCartDrawer();
            showModal(cart);
            setTimeout(function () {
              fetchCart().then(function (latestCart) {
                if (modal.classList.contains('is-open')) {
                  renderAll(latestCart);
                  renderJustAdded(latestCart);
                }
              });
            }, 600);
          });
        }, 400);
      }).catch(function () {});
      return response;
    });
  };

  // ---------- Form submit fallback ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    var isProductForm = form.matches('form[action*="/cart/add"]') || form.matches('form.shopify-product-form') || form.matches('product-form-component form');
    if (!isProductForm) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var selectedVariantId = parseInt(idInput.value, 10);
    var mainProduct = products[MAIN_HANDLE];
    if (!mainProduct) return;
    var isMainProduct = (mainProduct.variants || []).some(function (v) { return v.id === selectedVariantId; });
    if (!isMainProduct) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Cart-Upsell': '1' },
      body: formData
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          submitBtn.classList.remove('is-loading', 'is-added', 'is-success', 'cart-success', 'has-success', 'added');
          var atcComponent = submitBtn.closest('add-to-cart-component');
          if (atcComponent) {
            atcComponent.classList.remove('is-loading', 'is-added', 'is-success', 'added');
          }
        }

        setTimeout(function () {
          fetchCart().then(function (cart) {
            forceCloseCartDrawer();
            showModal(cart);
            setTimeout(function () {
              fetchCart().then(function (latestCart) {
                if (modal.classList.contains('is-open')) {
                  renderAll(latestCart);
                  renderJustAdded(latestCart);
                }
              });
            }, 600);
          });
        }, 400);
      })
      .catch(function (err) {
        console.error('[cart-upsell] form submit error', err);
        if (submitBtn) { submitBtn.disabled = false; }
      });
  }, true);
})();